import { TagWithMetadata } from 'app/api/tag-queries';
import { buildChainContaining } from '../Footer/tagChainUtils';

export type ChainListEntry = { kind: 'chain'; rootId: string; tags: TagWithMetadata[] } | { kind: 'single'; tag: TagWithMetadata };

export function groupTagsIntoChains(filteredTags: TagWithMetadata[], allTags: TagWithMetadata[]): ChainListEntry[] {
  const predecessorOf = new Map<string, string>();
  for (const tag of allTags) {
    if (tag.nextSegment) predecessorOf.set(tag.nextSegment, tag.id);
  }

  const rootOf = (id: string): string => {
    let current = id;
    const seen = new Set<string>([id]);
    while (predecessorOf.has(current)) {
      const prev = predecessorOf.get(current)!;
      if (seen.has(prev)) break;
      seen.add(prev);
      current = prev;
    }
    return current;
  };

  const filteredIds = new Set(filteredTags.map((t) => t.id));
  const entries: ChainListEntry[] = [];
  const seenRoots = new Set<string>();

  for (const tag of filteredTags) {
    const chain = buildChainContaining(allTags, tag.id);
    if (chain.length <= 1) {
      entries.push({ kind: 'single', tag });
      continue;
    }
    const root = rootOf(tag.id);
    if (seenRoots.has(root)) continue;
    seenRoots.add(root);
    entries.push({ kind: 'chain', rootId: root, tags: chain.filter((c) => filteredIds.has(c.id)) });
  }

  return entries;
}
